<template>
  <section class="container pb-8" :style="styles">
    <ul
      v-if="data?.slides?.length"
      class="flex flex-col gap-2 lg:flex-row lg:flex-wrap lg:gap-0"
    >
      <li v-for="item in data.slides" :key="item.id" class="relative lg:w-1/3">
        <UiLazyImg
          :src="item.file?.url"
          :src-mobile="item.fileMobile?.url"
          :alt="
            item?.file?.alt ||
            item.buttonLabel ||
            removeHTMLTagFromString(item?.title || '') ||
            'Image'
          "
          cover
        />
        <div class="text-center absolute left-0 bottom-0 w-full px-4 pb-8">
          <nuxt-link
            v-if="item.buttonUrl && item.buttonLabel"
            :to="localePath(item.buttonUrl)"
            target="_blank"
            class="ui-text-m text-white font-medium uppercase hover:underline underline-offset-2"
          >
            {{ item.buttonLabel }}
          </nuxt-link>
          <span
            v-else-if="item.buttonLabel"
            class="ui-text-m text-white font-medium uppercase"
          >
            {{ item.buttonLabel }}
          </span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
const props = defineProps<{ data: BlockSliderContent }>();

const { lgAndUp } = useAppBreakpoints();
const localePath = useLocalePathPolyfill();

const styles = computed(() => {
  return {
    backgroundColor: lgAndUp.value
      ? props.data?.backgroundColor?.hexa || "#000"
      : props.data?.backgroundColorMobile?.hexa ||
        props.data?.backgroundColor?.hexa ||
        "#000",
  };
});
</script>
